import { Injectable, signal } from '@angular/core';

// Lets devToolsEntryGuard (which runs before any game component even exists, so it has nowhere
// of its own to render a modal) show the exact same warning card every game uses in-page. One
// instance of app-devtools-guard-modal is mounted at the app root (app.component.html) bound to
// this service's state.
@Injectable({ providedIn: 'root' })
export class DevToolsWarningStateService {
  readonly visible = signal(false);
  readonly reason = signal('Unusual activity detected on your account. Please try again later.');

  show(reason?: string): void {
    if (reason) this.reason.set(reason);
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
